import { createAction } from 'redux-actions';
import { getDeviationEntityId } from '../../redux/normalizr/schemas/deviation';
import { actionKey } from './constants';
export var setPageSafety = createAction("".concat(actionKey, ".ADS_SET_PAGE_SAFETY"), function (_a) {
    var safety = _a.safety;
    return ({ safety: safety });
});
export var recordDeviationSafety = createAction("".concat(actionKey, ".ADS_DEV_SAFETY"), function (_a) {
    var deviation = _a.deviation, safety = _a.safety;
    return ({
        deviationId: getDeviationEntityId(deviation),
        safety: safety,
    });
});
export var queueSafetyChangeForDeviation = createAction("".concat(actionKey, ".QUEUE_DEV_SAFETY"), function (_a) {
    var deviation = _a.deviation;
    return ({
        deviationId: getDeviationEntityId(deviation),
    });
});
//# sourceMappingURL=actions.js.map